import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { FileText, ArrowRight, Download } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHero } from "./Services";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export default function DigitalDownloads() {
  const { data } = useQuery({ queryKey: ["products"], queryFn: () => api.get("/downloads/products").then(r => r.data) });
  const [cat, setCat] = useState("all");
  const products = (data?.products || []).filter(p => cat === "all" || p.category === cat);
  const cats = data?.categories || [];

  return (
    <div>
      <PageHero label="Digital Downloads" title="Guides & checklists, ready instantly" subtitle="Practical PDF guides for websites, PC care, and automation. Secure instant download after purchase." />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        {cats.length > 1 && (
          <div className="flex flex-wrap gap-2 mb-8">
            {["all", ...cats].map(c => (
              <button key={c} onClick={() => setCat(c)} className={`px-4 py-1.5 rounded-full text-sm font-medium ${cat === c ? "bg-electric text-white" : "border border-slate-200 text-slate-600 hover:border-electric"}`}>{c === "all" ? "All" : c}</button>
            ))}
          </div>
        )}
        {products.length === 0 ? (
          <div className="rounded-xl bg-slate-50 border border-slate-200 p-10 text-center text-slate-500">No downloads available yet. Check back soon!</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {products.map(p => (
              <Link to={`/digital-downloads/${p.slug}`} key={p.id} data-testid={`product-card-${p.slug}`}
                className="group rounded-xl border border-slate-200 overflow-hidden hover:shadow-lg hover:border-electric transition-all flex flex-col">
                <div className="aspect-[16/10] tdw-hero-gradient relative grid place-items-center">
                  <div className="absolute inset-0 tdw-circuit opacity-40" />
                  <FileText className="relative h-14 w-14 text-tech" />
                  {p.featured && <span className="absolute top-3 left-3 text-[10px] font-mono uppercase tracking-wider bg-electric text-white px-2 py-0.5 rounded-full">Featured</span>}
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <span className="text-[10px] font-mono uppercase tracking-wider text-metallic">{p.category}</span>
                  <h3 className="mt-1 font-heading font-semibold text-navy group-hover:text-electric transition-colors">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-2 flex-1">{p.description}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xl font-heading font-bold text-navy">{money(p.price)}</span>
                    <span className="text-sm font-medium text-electric flex items-center gap-1">Get it <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-1 transition-transform" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
